import { render, staticRenderFns } from "./NewChatContact.vue?vue&type=template&id=74f010a2&scoped=true&"
import script from "./NewChatContact.vue?vue&type=script&lang=js&"
export * from "./NewChatContact.vue?vue&type=script&lang=js&"
import style0 from "./NewChatContact.vue?vue&type=style&index=0&id=74f010a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f010a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
